import CountrySelector from '@components/CountrySelector';
import ErrorMsg from '@components/ErrorMsg';
import { useTranslations } from 'next-intl';

export default function FieldsRepeater({
  fields,
  errors,
  error,
  register,
  setValue,
  trigger,
  t = (a: any) => a,
  inputClasses,
  data,
}: {
  fields: any[];
  errors: any;
  error?: any;
  register: any;
  setValue: any;
  trigger: any;
  t?: any;
  inputClasses?: string;
  data?: any;
}) {
  const g = useTranslations('general');
  const allData = data;
  inputClasses = inputClasses || 'text-black w-full block py-2 px-3';
  return (
    <>
      {fields.map((field: any) => {
        if (field.skip) {
          return null;
        }
        let type = field.type ?? 'text';
        if (field.values) {
          type = 'values';
        }
        let data = allData;
        const registerName = String(field.name);
        const label =
          field.label ??
          t(
            field.name
              .split('.')
              .slice(-1)[0]
              .replace(/_([a-z])/g, function (g: string) {
                return g[1].toUpperCase();
              })
          );
        let dataValue = data ? data[field.name as keyof typeof data] : '';
        if (field.name.includes('.')) {
          let names = field.name.split('.');
          data = data ? allData[names[0]] : null;
          dataValue = data ? data[names[1]] : '';
        }
        return (
          <label className='mt-2 flex flex-col gap-1' key={field.name}>
            <span>{label} {field.required ? <span className='text-brand-alt'>*</span> : null}</span>
            {type === 'values' &&
              field.values.map(
                (
                  value:
                    | string
                    | number
                    | { value: string | number; label: string }
                ) => {
                  let option;
                  if (typeof value === 'string') {
                    option = {
                      value: value,
                      label: value.charAt(0).toUpperCase() + value.slice(1),
                    };
                  } else if (typeof value === 'number') {
                    option = {
                      value: value,
                      label: value,
                    };
                  } else {
                    option = value;
                  }
                  return (
                    <label key={option.value}>
                      <input
                        type={field.type === 'boolean' ? 'checkbox' : 'radio'}
                        {...register(registerName, {
                          required: {
                            value: !!field.required,
                            message: g('required'),
                          },
                        })}
                        value={option.value}
                        className='mr-2'
                      />
                      {option.label}
                    </label>
                  );
                }
              )}
            {['text', 'number', 'date', 'email'].includes(type) && (
              <input
                {...register(registerName, {
                  value: dataValue,
                  required: {
                    value: field.required ? true : false,
                    message: g('required'),
                  },
                })}
                type={type}
                className={inputClasses}
              />
            )}
            {type === 'textarea' && (
              <textarea
                {...register(registerName, {
                  required: {
                    value: field.required ? true : false,
                    message: g('required'),
                  },
                })}
                className={inputClasses}
              >
                {dataValue}
              </textarea>
            )}
            {type === 'country' && (
              <>
                <CountrySelector
                  country={dataValue}
                  placeholder={label}
                  onChange={(option: any) => {
                    setValue(registerName, option.value);
                    trigger(field.name);
                  }}
                />
                <input
                  type='hidden'
                  {...register(registerName, {
                    value: dataValue,
                    required: {
                      value: !!field.required,
                      message: g('required'),
                    },
                  })}
                />
              </>
            )}
            <ErrorMsg errors={errors} error={error} name={registerName} />
          </label>
        );
      })}
    </>
  );
}
